/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedSearchSuggestions_itemSearch$ref = any;
export type SbSharedForceSearchLink_itemSearch$ref = any;
export type SbSharedForceSearchLink_itemSearch = {
    readonly pageType: string | null;
    readonly searchCorrections: {
        readonly forceSearchUri: string | null;
        readonly originalSearchTerm: string | null;
        readonly semanticSearchTerm: string | null;
    } | null;
    readonly " $fragmentRefs": SbSharedSearchSuggestions_itemSearch$ref;
    readonly " $refType": SbSharedForceSearchLink_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedForceSearchLink_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "searchCorrections",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchCorrectionsType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "forceSearchUri",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "originalSearchTerm",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "semanticSearchTerm",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSearchSuggestions_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'dd76b7d2919134ab09f8d664ce055cbc';
export default node;
